enum TYPE_CIVILITE {
  MADAME = "Madame",
  MONSIEUR = "Monsieur",
  AUTRE = "Autre",
}
export default TYPE_CIVILITE;
